<template>
  <div>
    <div v-if="!isLoad">
      <v-main class="bg-[#F7FAFB] dark-bg-default" style="padding: 0px">
        <v-col>
          <v-tabs
            v-model="tabs"
            align-with-title
            :color="$vuetify.theme.currentTheme.primary"
          >
            <v-tab
              :ripple="false"
              v-for="(tab, index) in filteredTabItems"
              :key="index"
              class="mr-12 ml-0"
              :color="$vuetify.theme.currentTheme.primary"
            >
              {{ tab.name }}
            </v-tab>
            <v-tabs-slider color="#32D583"></v-tabs-slider>
            <div
              class="flex items-center absolute right-0 pr-4"
              v-if="currentTab === 'CallHistory'"
              style="top: 0; height: 100%"
            >
              <div class="text-orange-600 mr-4">
                <span> Total Calls: {{ totalCalls }} </span>
              </div>
              <div class="border-l border-gray-300 h-6 mx-4"></div>
              <div class="text-green-600">
                <span> Connected Calls: {{ connectedCalls }} </span>
              </div>
            </div>
          </v-tabs>
        </v-col>
        <component
          :is="currentTab"
          :caseConfig="caseConfig"
          :employees="employees"
          :orgConfig="orgConfig"
          @retry-call="openDialerPopOver"
          @callStats="callStats"
        ></component>
      </v-main>
    </div>
    <div
      v-else
      class="absolute w-full h-screen flex-col items-center flex justify-center"
    >
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
    <DialerPopOver
      v-if="showDialer"
      :callItem="callItem"
      @handleCloseDialer="closeDialerPopOver"
      class="absolute top-0 left-0"
    />
  </div>
</template>

<script>
import Cases from "@/components/Workforce/CollectionManagement/CaseModules/CaseTable.vue";
import Visits from "@/components/Workforce/CollectionManagement/VisitModules/VisitTable.vue";
import CaseAnalytics from "@/components/Workforce/CollectionManagement/CaseModules/CaseAnalytics.vue";
import CallHistory from "@/components/Workforce/CollectionManagement/CaseModules/CallHistory.vue";
import Customer from "./CollectionCustomer.vue";

import { isModuleFeatureAllowed } from "@/utils/common";
import DialerPopOver from "@/components/DialerPopOver.vue";

export default {
  name: "CollectionPage",
  layout: "Workforce/default",
  components: {
    Cases,
    Visits,
    CaseAnalytics,
    CallHistory,
    DialerPopOver,
    Customer,
  },
  data() {
    return {
      userData: this.$storage.getUniversal("user"),
      tabs: 0,
      caseConfig: null,
      orgConfig: null,
      employees: [],
      isLoad: true,
      showDialer: false,
      callItem: null,
      connectedCalls: 0,
      totalCalls: 0,
    };
  },
  computed: {
    currentTab() {
      return this.filteredTabItems[this.tabs]?.component;
    },
    filteredTabItems() {
      return this.tabItems.filter((tab) => {
        if (tab.key === "CaseAnalytics") {
          return this.isFeatureVisible("DASHBOARD", "SHOW_CASE_ANALYTICS");
        }
        if (tab.key === "CallHistory") {
          return this.isFeatureVisible("ADDONS", "CALL_A_CUSTOMER");
        }
        return true;
      });
    },
    tabItems() {
      const tabs = [
        {
          key: "Cases",
          name:
            this.caseConfig.tableTabMapping?.caseTable?.displayName || "Cases",
          component: "Cases",
        },
        {
          key: "Visits",
          name:
            this.caseConfig.tableTabMapping?.visitTable?.displayName ||
            "Visits",
          component: "Visits",
        },
        {
          key: "CaseAnalytics",
          name:
            this.caseConfig.tableTabMapping?.caseAnalyticsTable?.displayName ||
            "Case Analytics",
          component: "CaseAnalytics",
        },
        {
          key: "CallHistory",
          name:
            this.caseConfig.tableTabMapping?.callHistoryTable?.displayName ||
            "Call History",
          component: "CallHistory",
        },
        {
          key: "CaseCustomer",
          name:
            this.caseConfig.tableTabMapping?.customerTable?.displayName ||
            "Customers",
          component: "Customer",
        },
      ];
      return tabs;
    },
  },
  watch: {
    "$route.params.subCase": async function (newQuery) {
      if (newQuery) {
        await this.refetchData();
      }
    },
  },
  async mounted() {
    await this.refetchData();
  },
  methods: {
    openDialerPopOver(item) {
      this.callItem = item;
      this.showDialer = true;
    },
    closeDialerPopOver() {
      this.showDialer = false;
      this.callId = null;
    },
    callStats(val) {
      if (val) {
        this.totalCalls = val.totalCalls;
        this.connectedCalls = val.result;
      } else {
        this.totalCalls = 0;
        this.connectedCalls = 0;
      }
    },
    async refetchData() {
      await this.fetchUsers();
      const config = await this.getConfig();
      const subCaseId = this.$route.params.subCase;
      let caseConfig;

      config.enabledSubCases.forEach((scItem) => {
        caseConfig = scItem.subCase.find((sc) => sc._id === subCaseId);
      });
      this.orgConfig = config;
      this.caseConfig = caseConfig;
      this.tabs = 0;
      this.isLoad = false;
    },
    async getConfig() {
      try {
        const response = await this.$axios.get("/workforce/org/config");

        const data = response.data?.config;
        return data || {};
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    },
    async fetchUsers() {
      try {
        const params = {
          limit: "*",
          sortBy: "firstName",
          sortOrder: "asc",
        };
        if (
          this.userData?.branch &&
          !this.userData?.role?.includes("WFM_ADMIN")
        ) {
          params.branch = this.userData?.branch;
        }
        if (this.caseConfig?.branch) {
          params.branch = this.caseConfig?.branch;
        }
        const response = await this.$axios.get("/workforce/v2/users", {
          params,
        });
        this.employees = response.data?.users;
      } catch (error) {
        console.log(error);
      }
    },
    isFeatureVisible(module, feature) {
      return isModuleFeatureAllowed(module, feature);
    },
  },
};
</script>

<style scoped>
.v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: 16px;
}
</style>
